import React, { useState } from 'react'
import { MenuItem, Menu, Tooltip, Button, IconButton, Divider, Typography } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTableStore } from 'state/TableStore';
import EditIcon from '@mui/icons-material/Edit';
import { getCurrentEnv, logger } from "../../../utils";
import { useUserStore } from 'state';
import dayjs from 'dayjs';

export const Actions: React.FC<any> = ({ row, pageName, isCurrentRowClicked, rowClickHandler, tableName }) => {
    const userConfig = useUserStore(state => state.userConfig)
    const config = useUserStore(state => state.config)
    const { usersPermissions } = userConfig;
    const { maxExtensions, hardLimit } = config.transactionViewing

    const setExtendModal = useTableStore(state => state.setExtendModal)
    const [tcns, setTcns] = useState<Array<any>>([])
    const [anchorEl, setAnchorEl] = useState(null);
    const openActions = Boolean(anchorEl);

    const currentRow = useTableStore((state) => state.currentRow)
    const setCurrentRow = useTableStore((state) => state.setCurrentRow)
    const actionsConfig = useTableStore(state => state.actionsConfig)
    const setRowClicked = useTableStore(state => state.setRowClicked);
    const zoomLevel = useTableStore(state => state.zoomLevel);

    const popoverId = openActions ? 'actions-popover' : undefined;

    const handleOpenActions = (e: any, key: string) => {
        e.stopPropagation()
        setCurrentRow(key)
        setAnchorEl(e.currentTarget);
    }

    const handleClose = (e: any) => {
        e.stopPropagation()
        setAnchorEl(null);
        setRowClicked(false);
    };

    const debugExtend = {
        identifier: "debug extendView",
        pageName: "transaction-summary",
        thingToDebug: "Actions",
        paramsToLog: {
            actionsConfig
        }
    }

    // logger(debugExtend)

    console.log({pageName, actionsConfig, rowKeyOrId: row.key, rowId: row.id, row})

    return (
        <>
            {
                pageName === 'user-management'
                    ? currentRow === row.key &&
                    <Button size='small' sx={{ width: `67px`, height: `30px` }} onClick={(e) => rowClickHandler(e, row)} data-testid="edit-button">
                        <EditIcon sx={{ mr: '0.5rem', width: `18px`, height: `18px` }} />
                        <Typography variant="button" sx={{ fontSize: `14px` }}>
                            Edit
                        </Typography>
                    </Button>
                    : (row.key ? row.key : row.id) && <Tooltip title="Open Actions">
                        <IconButton key={row.key}
                            sx={{ marginLeft: "", height: "20px", width: "20px" }}
                            data-testid="open-actions-icon-button"
                            onClick={(e: any) => {
                                e.stopPropagation();
                                handleOpenActions(e, row.key)
                            }
                            }>
                            <MoreVertIcon />
                        </IconButton>
                    </Tooltip>
            }
            {
                row.key === currentRow && (
                    <Menu
                        onClose={(e) => handleClose(e)}
                        slotProps={{ paper: { sx: { width: (pageName === 'transaction-summary' || pageName === 'applicant-details') ? '220px' : '270px', backgroundColor: "background.default", border: "none", display: 'flex', flexDirection: "column" } } }}
                        id={popoverId}
                        open={openActions}
                        data-testid="actions-menu"
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        anchorEl={anchorEl}
                        MenuListProps={{ 'aria-labelledby': 'basic-button' }}>
                        {
                            (pageName === 'transaction-summary' || pageName === 'applicant-details' || pageName === 'rapback-summary') && (
                                actionsConfig.map((action, index) => {
                                    console.log('debug actions actionsCofnig: ', actionsConfig, row)
                                    const disableExtend = (row.extendCount >= maxExtensions || dayjs(row?.transactionDate).add(hardLimit, 'days').isBefore(dayjs()))
                                    return (action.actionLabel === "Extend"
                                        ? usersPermissions?.extendTransactionRecord &&
                                        <MenuItem disabled={disableExtend} key={index}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                handleClose(e)
                                                action.actionHandler(e, row)
                                            }}
                                            data-testid="actions-menu-item"
                                            sx={{ width: "270px", height: "36px", pointerEvents: disableExtend ? "none" : "" }}>
                                            {action.actionLabel}
                                        </MenuItem>
                                        : action.actionLabel === "_divider" ? <Divider /> : <MenuItem key={index}
                                            disabled={action.actionLabel === "No PDF available" ? true : false}
                                            data-testid="actions-menu-item"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                handleClose(e)
                                                action.actionHandler(e, row)
                                            }}
                                            sx={{ width: '270px', height: "36px", }}>
                                            {action.actionIcon ? action.actionIcon : <></>}
                                            {action.actionLabel}
                                        </MenuItem>
                                    )
                                })
                            )
                        }

                        {
                            pageName === 'rapback-maintenance' && (
                                actionsConfig.map((action, index) => {
                                    return (
                                        action.actionLabel === "_divider"
                                            ? <Divider />
                                            : <MenuItem key={index}
                                                disabled={(action.actionLabel === "Edit Subscription" || action.actionLabel === "Unsubscribe") && (row.status?.toLowerCase() === "unsubscribed" || row.status?.toLowerCase().includes("pending"))}
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    handleClose(e)
                                                    action.actionHandler(e, row)
                                                }}
                                                data-testid="actions-menu-item"
                                                sx={{ width: "270px", height: "36px" }}>
                                                {action.actionLabel}
                                            </MenuItem>
                                    )
                                })

                            )
                        }
                        {
                            pageName === 'rapback-prenotifications' && (
                                actionsConfig.map((action, index) => {
                                    return (
                                        <MenuItem
                                            key={index}
                                            data-testid="actions-menu-item"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                handleClose(e)
                                                action.actionHandler(e, row)
                                            }}
                                            sx={{ width: "270px", height: "36px" }}>
                                            {action.actionLabel}
                                        </MenuItem>
                                    )
                                })
                            )
                        }
                        {
                            pageName === 'rapback-validations' && (
                                actionsConfig.map((action, index) => {
                                    return (
                                        <MenuItem
                                            disabled={Math.sign(row.timeRemaining) < 1 ? true : false}
                                            data-testid="actions-menu-item"
                                            key={index}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                handleClose(e)
                                                action.actionHandler(e, row)
                                            }}
                                            sx={{ width: "270px", height: "36px" }}>
                                            {action.actionLabel}
                                        </MenuItem>
                                    )
                                })
                            )
                        }
                    </Menu>
                )
            }
        </>
    )

}
